<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="swiper-container swiper-nav-bullets swiper-featured" style="margin: -30px 0 0 0;">
                <swiper [config]="swiperConfig">
                    <ng-template swiperSlide class="swiper-slide">
                        <div class="card-row">
                            <div class="row">
                                <div class="align-items-center col-md-7 col-xl-6 d-flex justify-content-center">
                                    <div>
                                        <img src="images/beneficio-slide-1.webp" class="featured-img img-fluid mgn-bottom-25 rounded-lg swiper-lazy" alt="Detalle vista base de datos de ProfeJOBS" loading="lazy"/>
                                    </div>
                                </div>
                                <div class="align-items-center col-md-5 col-xl-6 d-flex">
                                    <div>
                                        <h3 class="slide-title">Beneficios de reclutar con&nbsp;
                                            <span class="enphasis">ProfeJOBS</span>
                                        </h3>
                                        <div class="mgn-bottom-40 tips-component">
                                            <ul class="tips-group">
                                                <li class="tip pj-ico">
                                                    <h4 class="tip-title">Centraliza y agranda tu base de contactos</h4>
                                                    <p>Los profesores pueden postular a anuncios publicados por ti, o bien Enviar CV a tu institución para futuras oportunidades. Además, podrás canjear créditos para desbloquear perfiles desde nuestra comunidad completa.</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="text-center">
                                            <a class="bg-gradient-color-cyan-rigth btn btn-box-shadow-cyan no-text-transform round-btn text-white" [routerLink]="'/'+[path_module_public.landing_premium]">Más información</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div class="card-row">
                            <div class="row">
                                <div class="align-items-center col-md-7 col-xl-6 d-flex justify-content-center">
                                    <div>
                                        <img src="images/beneficio-slide-2.webp" class="featured-img img-fluid mgn-bottom-25 rounded-lg swiper-lazy" alt="Modal ficha del profesor" loading="lazy"/>
                                    </div>
                                </div>
                                <div class="align-items-center col-md-5 col-xl-6 d-flex">
                                    <div>
                                        <h3 class="slide-title">Beneficios de reclutar con&nbsp;
                                            <span class="enphasis">ProfeJOBS</span>
                                        </h3>
                                        <div class="mgn-bottom-40 tips-component">
                                            <ul class="tips-group">
                                                <li class="tip pj-ico">
                                                    <h4 class="tip-title">Evita perder tiempo pidiendo antecedentes a postulantes</h4>
                                                    <p>Revisa a cada postulante en 360º y descarga directamente certificados, diplomas, etc. de los profesores.
    Evita perder tiempo pidiendo antecedentes.</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="text-center">
                                            <a class="bg-gradient-color-cyan-rigth btn btn-box-shadow-cyan no-text-transform round-btn text-white" target="_self" [routerLink]="'/'+[path_module_public.landing_premium]">Más inforrmación</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div class="card-row">
                            <div class="row">
                                <div class="align-items-center col-md-7 col-xl-6 d-flex justify-content-center">
                                    <div>
                                        <img src="images/beneficio-slide-3.webp" class="featured-img img-fluid mgn-bottom-25 rounded-lg swiper-lazy" alt="Vista explorar candidatos de ProfeJOBS" loading="lazy"/>
                                    </div>
                                </div>
                                <div class="align-items-center col-md-5 col-xl-6 d-flex">
                                    <div>
                                        <h3 class="slide-title">Beneficios de reclutar con&nbsp;
                                            <span class="enphasis">ProfeJOBS</span>
                                        </h3>
                                        <div class="mgn-bottom-40 tips-component">
                                            <ul class="tips-group">
                                                <li class="tip pj-ico">
                                                    <h4 class="tip-title">Filtra, ¡y llega a la persona exacta!</h4>
                                                    <p>ProfeJOBS posee un buscador único en el rubro. Mediante búsquedas avanzadas, podrás llegar a cualquier
    persona de nuestra base, y podrás invitarla a postular a tus procesos.</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="text-center">
                                            <a class="bg-gradient-color-cyan-rigth btn btn-box-shadow-cyan no-text-transform round-btn text-white" target="_self" [routerLink]="'/'+[path_module_public.landing_premium]">Más información</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div class="card-row">
                            <div class="row">
                                <div class="align-items-center col-md-7 col-xl-6 d-flex justify-content-center">
                                    <div>
                                        <img src="images/beneficio-slide-4.webp" class="featured-img img-fluid mgn-bottom-25 rounded-lg swiper-lazy" alt="Detalle kanban de ProfeJOBS" loading="lazy"/>
                                    </div>
                                </div>
                                <div class="align-items-center col-md-5 col-xl-6 d-flex">
                                    <div>
                                        <h3 class="slide-title">Beneficios de reclutar con&nbsp;
                                            <span class="enphasis">ProfeJOBS</span>
                                        </h3>
                                        <div class="mgn-bottom-40 tips-component">
                                            <ul class="tips-group">
                                                <li class="tip pj-ico">
                                                    <h4 class="tip-title">Somos la plataforma de reclutamiento más amigable del rubro</h4>
                                                    <p>En ProfeJOBS queremos simplificar la vida de reclutadores.
    ¡Te sorprenderás por lo intuitiva de nuestra plataforma!</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="text-center">
                                            <a class="bg-gradient-color-cyan-rigth btn btn-box-shadow-cyan no-text-transform round-btn text-white" target="_self" [routerLink]="'/'+[path_module_public.landing_premium]">Más información</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </swiper>
                 
                <div id="swiper-pagination-employer-benefit" class="swiper-pagination"></div>
                <div class="controls-swiper-wrapper-2">
                    <div id="swiper-pagination-employer-benefit-prev" class="swiper-button-prev swiper-card-prev"></div>
                    <div id="swiper-pagination-employer-benefit-next" class="swiper-button-next swiper-card-next"></div>
                </div>
            </div>
        </div>
    </div>
</div>